export default {
sidebarOpen : state => state.sidebarOpen
}
